<template>
  <div id="app">
    <!-- 头部组件 -->
    <Header :currentRoute="$route.path" v-if="isScrolled"/>

    <!-- 主内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 底部组件 -->
    <Footer />
  </div>
</template>

<script>
// 引入 Header 和 Footer 组件
import Header from '../src/components/Header.vue';
import Footer from "../src/components/Footer.vue";

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isScrolled: true, // 判断是否滚动到指定位置
    };
  },
  methods: {
    handleScroll() {
      // 获取当前页面滚动的距离
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      // 当滚动位置大于 300px 时触发
      if (scrollPosition > 500) {
        this.isScrolled = false;
      } else {
        this.isScrolled = true;
      }
    },
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.article-content p {
	
		 line-height: 2 !important;
		     margin-top: .75em;
    margin-bottom: 0;
		
		
	}
.article-content {
  white-space: pre-wrap;   /* 保留换行和空格 */
  line-height: 1.8;
  
  strong, b {
    font-weight: 600;   /* 600 或 700 均可 */
  }
}

/* 滚动到指定位置时显示的消息 */
.scroll-message {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  border-radius: 5px;
}
</style>
